export const useClientVersion = () => {
  return PROJECT_VERSION;
};
